import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { RgLimitInfoData } from '../../../model/depositInfo.model';
import { BehaviorDataService } from '../../../service/behaviorData.service';
import { DataService } from '../../../service/data.service';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'threshold-limit-messages',
    templateUrl: 'threshold-limit-messages.component.html',
    imports: [TranslateModule, DynamicHtmlDirective],
})
export class ThresholdLimitMessagesComponent implements OnInit, OnDestroy {
    private behaviourData = inject(BehaviorDataService);
    private translateService = inject(TranslateService);
    dataService = inject(DataService);

    inputData: RgLimitInfoData;
    dailyLimitBucketOne: any;
    dailyLimitBucketTwo: any;
    dailyLimitBucketThree: any;
    enteredAmount: any;
    weeklyLimitBucketOne: number;
    weeklyLimitBucketTwo: number;
    weeklyLimitBucketThree: number;
    monthlyLimitBucketOne: number;
    monthlyLimitBucketTwo: number;
    monthlyLimitBucketThree: number;
    showMessage: boolean;
    frequency: string;
    isRgLimitMet: boolean;
    isDailyThresholdLimit: boolean;
    isWeeklyThresholdLimit: boolean;
    isMonthlyThresholdLimit: boolean;
    isDailyRgLimitExceeded: boolean;
    isDailyRgLimitMet: boolean;
    isWeeklyRgLimitMet: boolean;
    isMonthlyRgLimitMet: boolean;
    amount: number;
    daily: number;
    weekly: number;
    monthly: number;
    isDailyBucketThree: boolean;
    isDailyBucketTwo: boolean;
    isDailyBucketOne: boolean;
    isWeeklyBucketTwo: boolean;
    isWeeklyBucketOne: boolean;
    isWeeklyBucketThree: boolean;
    isMonthlyBucketOne: boolean;
    isMonthlyBucketTwo: boolean;
    isMonthlyBucketThree: boolean;
    dailyCurrentBucket: string;
    weeklyCurrentBucket: string;
    monthlyCurrentBucket: string;
    isBucketChanged: boolean = true;
    increaseLimitUrl: any;
    rgLimitInfo: any;

    getRgLimitInfo() {
        if (this.dataService.RgLimitData) {
            const data: any = this.dataService.RgLimitData;
            if (data) {
                this.inputData = data;
                this.setBucketValues();
            }
        }
    }

    getCurrentBucket() {
        this.inputData?.rglimitInfo?.forEach((item) => {
            if (item.type === 'Daily') {
                if (item.actualPurchase.value >= this.dailyLimitBucketOne && item.actualPurchase.value < this.dailyLimitBucketTwo) {
                    this.dailyCurrentBucket = 'first';
                } else if (item.actualPurchase.value >= this.dailyLimitBucketTwo && item.actualPurchase.value < this.dailyLimitBucketThree) {
                    this.dailyCurrentBucket = 'second';
                } else if (item.actualPurchase.value >= this.dailyLimitBucketThree && item.actualPurchase.value < item.rgLimit.value) {
                    this.dailyCurrentBucket = 'third';
                }
            } else if (item.type === 'Weekly') {
                if (item.actualPurchase.value >= this.weeklyLimitBucketOne && item.actualPurchase.value < this.weeklyLimitBucketTwo) {
                    this.weeklyCurrentBucket = 'first';
                } else if (item.actualPurchase.value >= this.weeklyLimitBucketTwo && item.actualPurchase.value < this.weeklyLimitBucketThree) {
                    this.weeklyCurrentBucket = 'second';
                } else if (item.actualPurchase.value >= this.weeklyLimitBucketThree && item.actualPurchase.value < item.rgLimit.value) {
                    this.weeklyCurrentBucket = 'third';
                }
            } else if (item.type === 'Monthly') {
                if (item.actualPurchase.value >= this.monthlyLimitBucketOne && item.actualPurchase.value < this.monthlyLimitBucketTwo) {
                    this.monthlyCurrentBucket = 'first';
                } else if (item.actualPurchase.value >= this.monthlyLimitBucketTwo && item.actualPurchase.value < this.monthlyLimitBucketThree) {
                    this.monthlyCurrentBucket = 'second';
                } else if (item.actualPurchase.value >= this.monthlyLimitBucketThree && item.actualPurchase.value < item.rgLimit.value) {
                    this.monthlyCurrentBucket = 'third';
                }
            }
        });
        this.toggleLimitMsg();
    }
    ngOnInit() {
        this.getRgLimitInfo();
        this.behaviourData.getEnteredAmount.subscribe((message) => {
            if (message) {
                this.enteredAmount = message;
                this.showMessage = false;
                this.frequency = '';
                this.isDailyBucketOne = false;
                this.isDailyBucketTwo = false;
                this.isDailyBucketThree = false;
                this.isDailyThresholdLimit = false;
                this.isDailyRgLimitMet = false;
                this.dailyCurrentBucket = '';
                this.isWeeklyRgLimitMet = false;
                this.isWeeklyBucketOne = false;
                this.isWeeklyBucketTwo = false;
                this.isWeeklyBucketThree = false;
                this.weeklyCurrentBucket = '';
                this.isWeeklyThresholdLimit = false;
                this.isMonthlyRgLimitMet = false;
                this.isMonthlyThresholdLimit = false;
                this.isMonthlyBucketOne = false;
                this.isMonthlyBucketTwo = false;
                this.isMonthlyBucketThree = false;
                this.monthlyCurrentBucket = '';
                this.isBucketChanged = true;
                this.getCurrentBucket();
            }
        });
    }
    calculateBucketValues(bucketValue: any, rglimit: any) {
        return (bucketValue * rglimit) / 100;
    }

    setBucketValues() {
        this.inputData?.rglimitInfo?.forEach((item) => {
            if (item.days === 1) {
                item.type = 'Daily';
                this.dailyLimitBucketOne = this.calculateBucketValues(this.inputData.rg_first_bucket_threshold, item.rgLimit.value);
                this.dailyLimitBucketTwo = this.calculateBucketValues(this.inputData.rg_second_bucket_threshold, item.rgLimit.value);
                this.dailyLimitBucketThree = this.calculateBucketValues(this.inputData.rg_third_bucket_threshold, item.rgLimit.value);
            } else if (item.days <= 7) {
                item.type = 'Weekly';
                this.weeklyLimitBucketOne = this.calculateBucketValues(this.inputData.rg_first_bucket_threshold, item.rgLimit.value);
                this.weeklyLimitBucketTwo = this.calculateBucketValues(this.inputData.rg_second_bucket_threshold, item.rgLimit.value);
                this.weeklyLimitBucketThree = this.calculateBucketValues(this.inputData.rg_third_bucket_threshold, item.rgLimit.value);
            } else {
                item.type = 'Monthly';
                this.monthlyLimitBucketOne = this.calculateBucketValues(this.inputData.rg_first_bucket_threshold, item.rgLimit.value);
                this.monthlyLimitBucketTwo = this.calculateBucketValues(this.inputData.rg_second_bucket_threshold, item.rgLimit.value);
                this.monthlyLimitBucketThree = this.calculateBucketValues(this.inputData.rg_third_bucket_threshold, item.rgLimit.value);
            }
        });
    }

    toggleLimitMsg(): any {
        const amount = Number(this.enteredAmount);
        if (this.inputData) {
            this.inputData?.rglimitInfo?.forEach((item) => {
                if (item.type === 'Daily' && !item.requestPending) {
                    const calculatedAmnt = amount + item.actualPurchase.value;
                    if (calculatedAmnt <= item.rgLimit.value) {
                        if (calculatedAmnt >= this.dailyLimitBucketOne && calculatedAmnt < this.dailyLimitBucketTwo) {
                            this.showMessage = true;
                            this.isDailyRgLimitMet = false;

                            this.isDailyThresholdLimit = true;
                            this.isDailyBucketOne = true;
                        } else if (calculatedAmnt >= this.dailyLimitBucketTwo && calculatedAmnt < this.dailyLimitBucketThree) {
                            this.showMessage = true;
                            this.isDailyRgLimitMet = false;

                            this.isDailyThresholdLimit = true;
                            this.isDailyBucketTwo = true;
                        } else if (calculatedAmnt >= this.dailyLimitBucketThree && calculatedAmnt < item.rgLimit.value) {
                            this.showMessage = true;
                            this.isDailyRgLimitMet = false;

                            this.isDailyThresholdLimit = true;
                            this.isDailyBucketThree = true;
                        } else if (calculatedAmnt === item.rgLimit.value) {
                            this.showMessage = true;
                            this.isDailyRgLimitMet = true;

                            this.isDailyThresholdLimit = true;
                        } else if (calculatedAmnt > item.rgLimit.value) {
                            this.showMessage = false;

                            this.isDailyThresholdLimit = true;
                        }
                    }
                } else if (item.type === 'Weekly' && !item.requestPending) {
                    const calculatedAmnt = amount + item.actualPurchase.value;
                    if (calculatedAmnt >= this.weeklyLimitBucketOne && calculatedAmnt < this.weeklyLimitBucketTwo) {
                        this.showMessage = true;
                        this.isWeeklyRgLimitMet = false;
                        this.isWeeklyThresholdLimit = true;
                        this.isWeeklyBucketOne = true;
                    } else if (calculatedAmnt >= this.weeklyLimitBucketTwo && calculatedAmnt < this.weeklyLimitBucketThree) {
                        this.showMessage = true;
                        this.isWeeklyRgLimitMet = false;
                        this.isWeeklyThresholdLimit = true;
                        this.isWeeklyBucketTwo = true;
                    } else if (calculatedAmnt >= this.weeklyLimitBucketThree && calculatedAmnt < item.rgLimit.value) {
                        this.showMessage = true;
                        this.isWeeklyRgLimitMet = false;
                        this.isWeeklyThresholdLimit = true;
                        this.isWeeklyBucketThree = true;
                    } else if (calculatedAmnt === item.rgLimit.value) {
                        this.showMessage = true;
                        this.isWeeklyRgLimitMet = true;
                        this.isWeeklyThresholdLimit = true;
                    } else if (calculatedAmnt > item.rgLimit.value) {
                        this.showMessage = false;
                        this.isWeeklyThresholdLimit = true;
                    }
                } else if (item.type === 'Monthly' && !item.requestPending) {
                    const calculatedAmnt = amount + item.actualPurchase.value;
                    if (calculatedAmnt === item.rgLimit.value) {
                        this.showMessage = true;
                        this.isMonthlyRgLimitMet = true;
                        this.isMonthlyThresholdLimit = true;
                    } else if (calculatedAmnt > item.rgLimit.value) {
                        this.showMessage = false;
                        this.isMonthlyThresholdLimit = true;
                    } else {
                        if (calculatedAmnt >= this.monthlyLimitBucketOne && calculatedAmnt < this.monthlyLimitBucketTwo) {
                            this.showMessage = true;
                            this.isMonthlyRgLimitMet = false;
                            this.isMonthlyThresholdLimit = true;
                            this.isMonthlyBucketOne = true;
                        } else if (calculatedAmnt >= this.monthlyLimitBucketTwo && calculatedAmnt < this.monthlyLimitBucketThree) {
                            this.showMessage = true;
                            this.isMonthlyRgLimitMet = false;
                            this.isMonthlyThresholdLimit = true;
                            this.isMonthlyBucketTwo = true;
                        } else if (calculatedAmnt >= this.monthlyLimitBucketThree && calculatedAmnt < item.rgLimit.value) {
                            this.showMessage = true;
                            this.isMonthlyRgLimitMet = false;
                            this.isMonthlyThresholdLimit = true;
                            this.isMonthlyBucketThree = true;
                        }
                    }
                }
            });
        }
        if (
            (this.isDailyBucketOne && this.dailyCurrentBucket == 'first') ||
            (this.isDailyBucketTwo && this.dailyCurrentBucket == 'second') ||
            (this.isDailyBucketThree && this.dailyCurrentBucket == 'third') ||
            (this.isWeeklyBucketOne && this.weeklyCurrentBucket == 'first') ||
            (this.isWeeklyBucketTwo && this.weeklyCurrentBucket == 'second') ||
            (this.isWeeklyBucketThree && this.weeklyCurrentBucket == 'third') ||
            (this.isMonthlyBucketOne && this.monthlyCurrentBucket == 'first') ||
            (this.isMonthlyBucketTwo && this.monthlyCurrentBucket == 'second') ||
            (this.isMonthlyBucketThree && this.monthlyCurrentBucket == 'third')
        ) {
            this.showMessage = false;
            this.isBucketChanged = false;
            return false;
        } else {
            if (
                ((this.isMonthlyBucketOne || this.isMonthlyBucketTwo || this.isMonthlyBucketThree) &&
                    !this.isWeeklyBucketOne &&
                    !this.isWeeklyBucketTwo &&
                    !this.isWeeklyBucketThree &&
                    !this.isDailyBucketOne &&
                    !this.isDailyBucketTwo &&
                    !this.isDailyBucketThree &&
                    !this.isWeeklyRgLimitMet &&
                    !this.isDailyRgLimitMet &&
                    !this.isMonthlyRgLimitMet) ||
                (this.isDailyBucketOne && this.isMonthlyBucketTwo)
            ) {
                this.frequency = 'Monthly';
            } else if (
                ((this.isWeeklyBucketOne || this.isWeeklyBucketTwo || this.isWeeklyBucketThree) &&
                    !this.isDailyBucketOne &&
                    !this.isDailyBucketTwo &&
                    !this.isDailyBucketThree &&
                    !this.isWeeklyRgLimitMet &&
                    !this.isDailyRgLimitMet &&
                    !this.isMonthlyRgLimitMet) ||
                (this.isWeeklyBucketTwo && (this.isMonthlyBucketOne || this.isMonthlyBucketTwo)) ||
                (this.isDailyBucketOne && this.isWeeklyBucketTwo)
            ) {
                this.frequency = 'Weekly';
            } else if (
                (this.isDailyBucketOne || this.isDailyBucketTwo || this.isDailyBucketThree) &&
                !this.isWeeklyRgLimitMet &&
                !this.isDailyRgLimitMet &&
                !this.isMonthlyRgLimitMet
            ) {
                this.frequency = 'Daily';
            } else if (
                this.isMonthlyRgLimitMet ||
                (this.isMonthlyRgLimitMet && this.isDailyThresholdLimit) ||
                (this.isWeeklyThresholdLimit && this.isMonthlyRgLimitMet) ||
                (this.isWeeklyRgLimitMet && this.isMonthlyRgLimitMet) ||
                (this.isDailyRgLimitMet && this.isMonthlyRgLimitMet) ||
                (this.isDailyRgLimitMet && this.isWeeklyRgLimitMet && this.isMonthlyRgLimitMet)
            ) {
                this.frequency = 'Monthly';
            } else if (
                this.isWeeklyRgLimitMet ||
                (this.isWeeklyRgLimitMet && this.isDailyThresholdLimit) ||
                (this.isWeeklyRgLimitMet && this.isMonthlyThresholdLimit) ||
                (this.isDailyRgLimitMet && this.isWeeklyRgLimitMet)
            ) {
                this.frequency = 'Weekly';
            } else if (
                this.isDailyRgLimitMet ||
                (this.isDailyRgLimitMet && this.isWeeklyThresholdLimit) ||
                (this.isDailyRgLimitMet && this.isMonthlyThresholdLimit)
            ) {
                this.frequency = 'Daily';
            } else if (
                (this.isDailyThresholdLimit && this.isWeeklyThresholdLimit) ||
                (this.isDailyThresholdLimit && this.isMonthlyThresholdLimit) ||
                (this.isDailyThresholdLimit && this.isMonthlyThresholdLimit && this.isWeeklyThresholdLimit)
            ) {
                this.frequency = 'Daily';
            } else if (this.isWeeklyThresholdLimit && this.isMonthlyThresholdLimit) {
                this.frequency = 'Weekly';
            }
        }
    }
    translateFrequency() {
        return this.translateService.instant('PARTY.CASHIER.web.deposit.threshold.limit.' + this.frequency?.toLowerCase());
    }
    ngOnDestroy(): void {}
}
